function showImage(imageIndex, shouldAnimate = true) {
  const images = document.querySelectorAll(`#carousel-image-${imageIndex}`);
  for (const image of images) {
    if (image && image.parentElement) {
      image.parentElement.scrollTo({
        left: image.offsetLeft - image.parentElement.offsetLeft,
        behavior: shouldAnimate ? 'smooth' : 'instant',
      });
    }
  }
}

function scrollCarouselBarLeft() {
  const bar = document.getElementById('carousel-bar');
  bar.scrollTo({
    left: bar.scrollLeft - bar.clientWidth,
    behavior: 'smooth',
  });
}

function scrollCarouselBarRight() {
  const bar = document.getElementById('carousel-bar');
  bar.scrollTo({
    left: bar.scrollLeft + bar.clientWidth,
    behavior: 'smooth',
  });
}

class CarouselElement extends HTMLElement {
  constructor() {
    super();

    const defaultIndex = parseInt(this.dataset.defaultIndex ?? '0', 10);

    if (defaultIndex > 0) {
      showImage(defaultIndex, false);
    }

    this.addEventListener('scroll', this.onScroll);
  }

  onScroll(e) {
    const newIndex = Math.round(e.currentTarget.scrollLeft / (e.currentTarget.scrollWidth / this.children.length));
    for (const imageButton of document.getElementsByClassName('carousel-image-button')) {
      imageButton.style.outlineWidth = '0px';
    }
    const selectedImageButton = document.getElementById('carousel-image-button-' + newIndex);
    if (selectedImageButton) {
      selectedImageButton.style.outlineWidth = '2px';
      if (
        selectedImageButton.offsetTop >
        selectedImageButton.parentElement.scrollTop + selectedImageButton.parentElement.clientHeight
      ) {
        selectedImageButton.parentElement.scrollTo({
          left:
            selectedImageButton.offsetTop +
            selectedImageButton.clientHeight -
            selectedImageButton.parentElement.clientHeight,
          behavior: 'smooth',
        });
      } else if (
        selectedImageButton.offsetTop + selectedImageButton.clientHeight <
        selectedImageButton.parentElement.scrollTop
      ) {
        selectedImageButton.parentElement.scrollTo({
          left: selectedImageButton.offsetTop,
          behavior: 'smooth',
        });
      }
    }
  }
}
customElements.define('carousel-element', CarouselElement);
